import { createFileRoute } from '@tanstack/react-router';

import { Profile } from '@/features/settings';

export const Route = createFileRoute('/_auth/_org/settings/profile')({
  component: Profile,
  notFoundComponent: () => {
    return <p>Profile not found!</p>;
  },
});
